const bonusStyleToTitleMap = {
  tuttiigiochi: "Tutti i giochi",
  scommesse: "Scommesse",
  ippica: "Ippica",
  totocalcio: "Totocalcio",
  poker: "Poker",
  casino: "Casinò",
  skillgames: "Giochi di carte",
  lotterie: "Lotterie",
  bingo: "Bingo",
  quickGames: "Quick games",
  bonus: "Codice promo inserito",
  virtual: "virtual",
}

const bonusCodeDialogParam = "bonus-code-dialog"
const bonusDetailDialogParam = "bonus-detail-dialog"

function getBonusProductTitle(style?: string) {
  if (!style || !(style in bonusStyleToTitleMap)) return null
  return bonusStyleToTitleMap[style as keyof typeof bonusStyleToTitleMap]
}

export { bonusCodeDialogParam, bonusDetailDialogParam, getBonusProductTitle }
